import {
  FETCH_PLATFORM_RETAILERS_STATUS_REQUEST,
  FETCH_PLATFORM_RETAILERS_STATUS_SUCCESS,
  FETCH_PLATFORM_RETAILERS_STATUS_FAILURE
} from '../../actions/inbox/platformRetailersStatusActions';

const initialState = {
  data: null,
  retailerId: null,
  loading: false,
  error: null
};

export default function platformRetailersStatusReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PLATFORM_RETAILERS_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_PLATFORM_RETAILERS_STATUS_SUCCESS:
      return {
        data: action.payload.platformRetailersStatus,
        retailerId: action.payload.retailerId ?? null,
        loading: false,
        error: null
      };
    case FETCH_PLATFORM_RETAILERS_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
